/**
 * @generated SignedSource<<854a2f89bdfb4aa85b573f1a20805bf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminList_routines$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useTeamScheduleAdminScreenListData_Routine">;
  readonly " $fragmentType": "TeamScheduleAdminList_routines";
}>;
export type TeamScheduleAdminList_routines$key = ReadonlyArray<{
  readonly " $data"?: TeamScheduleAdminList_routines$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminList_routines">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamScheduleAdminList_routines",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTeamScheduleAdminScreenListData_Routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "1c3d006f42e51feff80558789c0fc74d";

export default node;
